module.exports = __webpack_public_path__ + "img/inter-6.8c2b891d.jpg";